import * as Enums from '@/utils/enums';
import Helper from '@/utils/helper';
import Fetch from '@/utils/Fetch';

const getProjectList = async (searchPhrase: any, pageSize: any, currentPage: any, sortExpression: any, sortDirection: any, toast = null) => {
    return await Fetch.post({
        url: `/Project/GetProjects`,
        params: {
          pageSize,
          pageIndex: currentPage - 1,
          sortExpression,
          sortDirection,
          searchPhrase,
        },
        toastCtx: toast
    });
};

const getProject = async (projectID: any) => {
    return await Fetch.get({
        url: `/Project/${projectID}`
    });
};

const customerHasProjects = async (customerID: any) => {
    const request = await Fetch.get({
        url: `/Project`,
        params: {
          customerID: customerID,
        }
    });
    return request.TotalResults > 0;
};

const closeProject = async (projectID: any) => {
    return await Fetch.get({
        url: `/Project/Close`,
        params: { id: projectID },
    });
};

export default {
    getProjectList,
    getProject,
    customerHasProjects,
    closeProject,
};
